module.exports = __webpack_public_path__ + "static/media/astronaut.a9c00583.svg";